import { Box, CircularProgress, Stack } from "@mui/material"
import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { LineChart, useLineChart } from "../../../app/component/features/lineChart"
import { useStore } from "../../../app/stores/store"

interface HomeTrendChartProps {
    isStation?: boolean;
}

const HomeTrendChart = ({ isStation }: HomeTrendChartProps) => {
    const { setChart, chartData, chartDataStation, loadingChart } = useStore().homeTrendChartStore
    const { selectedStation } = useStore().commonStore

    const currentData = isStation
        ? chartDataStation
        : chartData
    
    const { data, ref } = useLineChart(currentData?.labels, currentData?.dataSets)
    
    useEffect(() => {
        setChart(ref.current, isStation ? 'station' : 'system')
    }, [setChart, ref, isStation])

    return (
        <Box height={300}>
            {loadingChart 
                ? <Stack direction="row" justifyContent="center"><CircularProgress /></Stack> 
                : (
                    <LineChart 
                        title={selectedStation 
                            ? `${selectedStation.name}: ${isStation ? 'Station' : 'System'}` 
                            : 'Unknown'
                        } 
                        idPrefix={isStation ? 'station' : 'system'}
                        ref={ref} data={data} 
                    />
                )
            }
        </Box>
    )
}

export default observer(HomeTrendChart)